module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNGef90c59acbe218cca63ff99b7ad97664.ef90c59a.png";